import React, { useReducer } from 'react';
import { useToasts } from 'react-toast-notifications'
import { successToast, errorToast} from '../../utils/ToastUtil'

import UserContext from './UserContext'
import UserReducer from './UserReducer'

import { 
    GET_ACCOUNT_USER, 
    PATCH_ACCOUNT_USER,
    GET_ACCOUNT_IMG_USER,
    POST_ACCOUNT_IMG_USER,
    LOADING_FILE, 
    LOADING, 
} from "../../types";

import {getAccount, patchAccount, getImg, postImgAccount} from '../../http_services/user/index';

const UserState = (props) => {

  const { addToast } = useToasts();

    const initialState = {
        loading: false,
        error: null,
        loadingFile: false,
        user: null,
        file: null
    }

    const [state, dispatch] = useReducer(UserReducer, initialState);

    const getDataUser = async () => {
      try{
        loading();
        const dataUser = await getAccount();
        dispatch({
            type: GET_ACCOUNT_USER,
            payload: dataUser
          });
        loading();
      } catch(err) {
        addToast('Error al obtener la data', errorToast());
      }
    }

    const getImgAccount = async (img) => {
      try{
        loadingImg();
        const data = await getImg(img);
        dispatch({
            type: GET_ACCOUNT_IMG_USER,
            payload: data
          });
          loadingImg();
      } catch(err) {
        addToast('Error al cargar la imagen', errorToast());
        }
    }

    const uploadImgAccount = async(file, extension, type) => {
      try{
        loadingImg();
        const resp = await postImgAccount(file, extension, type);
        const data = { file, user: resp }
        dispatch({
            type: POST_ACCOUNT_IMG_USER,
            payload: data
          });
        loadingImg();
        addToast('Archivo Actualizado con éxito', successToast());
      } catch(err) {
        addToast('Error al cargar el archivo', errorToast());
      }
    }

    const updateDataAccount = async (data) => {
      try{
        loading();
        const dataUser = await patchAccount(data);
        dispatch({
            type: PATCH_ACCOUNT_USER,
            payload: dataUser
          });
        loading();
        addToast('Data Actualizada con éxito', successToast());
      } catch(err) {
        addToast('Error al actualizar data', errorToast());
      }
    }

    const loading = () => {
        dispatch({
          type: LOADING
        });
      }

      const loadingImg = () => {
        dispatch({
          type: LOADING_FILE
        });
      }

    return ( 
        <UserContext.Provider
        value={{
            loading: state.loading,
            loadingFile: state.loadingFile,
            error: state.error,
            user: state.user,
            file: state.file,
            getDataUser: getDataUser,
            getImgAccount: getImgAccount,
            updateDataAccount: updateDataAccount,
            uploadImgAccount: uploadImgAccount
        }}          
        >
            {props.children}
        </UserContext.Provider>
     );
}
 
export default UserState;